import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "control has-icons-left" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "icon is-left select-icon" }

import { LOAD_FLOW_LIST_OPTIONS } from '@/store/reports/actionTypes';
import { SET_REPORTING_FLOW } from '@/store/reports/mutationTypes';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import { useStore } from 'vuex';
import { computed, onBeforeMount, onMounted, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FlowReportFilters',
  setup(__props) {

const store = useStore();
const reportFlowsOptions = computed(() => store.getters.reportFlowsOptions);
const selectedFlowId = computed(() => store.getters.selectedFlowId);
const isReportLoading = computed(() => store.getters.isReportLoading);
const loadFlows = () => store.dispatch(LOAD_FLOW_LIST_OPTIONS);
const setFlowForReports = (flowId: string) => store.commit(SET_REPORTING_FLOW, flowId);

const flowId = ref('all');

onBeforeMount(() => (flowId.value = selectedFlowId.value));
onMounted(() => loadFlows());
watch(selectedFlowId, (newFlowId) => (flowId.value = newFlowId));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["select", { 'flow-select--disabled': isReportLoading.value }])
    }, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((flowId).value = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (setFlowForReports(flowId.value))),
        disabled: isReportLoading.value
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportFlowsOptions.value, (flow) => {
          return (_openBlock(), _createElementBlock("option", {
            key: flow.id,
            value: flow.id
          }, _toDisplayString(flow.name), 9, _hoisted_3))
        }), 128))
      ], 40, _hoisted_2), [
        [_vModelSelect, flowId.value]
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createVNode(FlowIcon, { class: "icon-1-3x dropdown-icons icon-adjustment flow-icon-adjustment" })
      ])
    ], 2)
  ]))
}
}

})